/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { DEFAULT_EMAIL_SUFFIX } from '@gh/config';
import { padStart, repeat, split } from 'lodash';

export function getDefaultEmail(local: string): string {
  return local ? local + DEFAULT_EMAIL_SUFFIX : '';
}

export function getEmailLocalName(email: string): string {
  return email.split('@')[0];
}

// tslint:disable no-magic-numbers
export function intColorToHexColor(intColor: number): string {
  return `#${padStart(((intColor) >>> 0).toString(16).slice(-6), 6, '0')}`; // tslint:disable-line no-bitwise
}

export function hexColorToIntColor(hexColor: string): Maybe<number> {
  if (!hexColor.includes('#')) {
    return;
  }
  const hex = split(hexColor, '#')[1];
  const formattedHexColor = (hex.length === 3)
    ? repeat(hex, 2)
    : hex;
  return parseInt(formattedHexColor, 16);
}

export function invertHexColor(hexColor: string): string {
  let intColor = parseInt(hexColor.substring(1), 16);
  intColor = 0xFFFFFF ^ intColor;

  let color = intColor.toString(16);
  color = ('000000' + color).slice(-6);

  return `#${color}`;
}
